import { createContext, useContext } from 'react';

import { DialogProps } from '@material-ui/core';

import { Context } from '../DialogComposite/context';

export type MuiDialogShellProps = Omit<
  DialogProps,
  'open' | 'onClose' | 'classes' | 'className' | 'children'
>;

export interface MuiContext extends Omit<Context, 'props'> {
  props: MuiDialogShellProps;
}

export const MuiDialogContext = createContext<MuiContext>({
  id: '--dialog-composite-mui-context-id--',
  open: false,
  static: false,
  onOpen: () => {},
  onClose: () => {},
  props: {},
  isLoading: false,
});

export const useMuiDialogContext = () => {
  return useContext(MuiDialogContext);
};
